import { render } from "./Summary.vue?vue&type=template&id=1bb98160&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=1bb98160&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb98160"]])

export default __exports__